export default function(view, fn) {
  return !fn ? null : function() {
    try {
      fn.apply(this, arguments);
    } catch (error) {
      view.error(error);
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-view/src/trap.js
// module id = 347
// module chunks = 0